<widget-wp-table [resource]="resource"
                 (resourceChanged)="onResourceChanged($event)" />
